var path = window.location.pathname;

      // Check if path ends with "/genuine" or starts with "/genuine/"
      if (path === '/genuine' || path.startsWith('/genuine/')) {
        // Redirect to new URL (change this to your target URL)
        window.location.href = '/';
      }